import { render, staticRenderFns } from "./help-card.vue?vue&type=template&id=f78cb9d0&scoped=true&lang=pug"
import script from "./help-card.vue?vue&type=script&lang=js"
export * from "./help-card.vue?vue&type=script&lang=js"
import style0 from "./help-card.vue?vue&type=style&index=0&id=f78cb9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78cb9d0",
  null
  
)

export default component.exports